import React, {Component} from 'react';
import {
  Dropdown,
  Menu,
  Icon,
  Layout,
  Popover,
  Button
} from 'antd';
import SiderMenu from './SiderMenu';
import UserChangePasswordModalForm from '../UserChangePasswordModalForm'

const {Header} = Layout;

class HeaderNav extends Component {
  state = {
    collapsed: this.props.collapsed,
    visible: false,
    visibleModal: false
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.error === "" && this.props.error === "" && this.state.visibleModal) {
      this.form.resetFields();
      this.setState({visibleModal: false})
    }
  }

  menuClick = e => {
    e.key === 'logout' && this.logout();
  };

  logout = () => {
    this.props.logout()
    this.props.router.push('/login')
  };

  popoverHide = () => {
    this.setState({visible: false});
  };

  handleVisibleChange = (visible) => {
    this.setState({visible});
  };

  toggleCollapsed = () => {
    this.props.toggle();
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  handleMenuSelection = (e) => {
    if (e.key === "change-pass") {
      return this.setState({visibleModal: true})
    }
  }

  handleCancel = () => {
    this.setState({visibleModal: false});
  }

  saveFormRef = (form) => {
    this.form = form;
  }

  handleUpdatePassword = () => {
    const form = this.form;
    const {currentUser} = this.props
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      const {password, newPassword} = values
      const updatePassword = {
        ID: currentUser.user_id,
        UserName: currentUser.user_name,
        Password: password,
        NewPassword: newPassword
      }
      this.props.onUpdatePassword(updatePassword)
    });
  };

  render() {
    const {isMobile, path, basePath, currentUser, error} = this.props
    const role = currentUser
      ? currentUser.role
      : 256
    const {visible, visibleModal, collapsed} = this.state
    const menu = (<Menu onClick={(e) => this.handleMenuSelection(e)}>
      <Menu.Item key="change-pass">
        <span>
          <a role="button">Đổi mật khẩu</a>
        </span>
      </Menu.Item>
      <Menu.Divider/>
      <Menu.Item key="logout">
        <span>
          <a role="button" onClick={this.logout}>Đăng xuất</a>
        </span>
      </Menu.Item>
    </Menu>)
    return (<Header className="header">
      {
        isMobile
          ? (<Popover content={<SiderMenu path = {
              path
            }
            basePath = {
              basePath
            }
            popoverHide = {
              this.popoverHide
            }
            isMobile = {
              isMobile
            }
            role = {
              role
            } />} trigger="click" placement="bottomLeft" visible={visible} onVisibleChange={this.handleVisibleChange}>
            <Icon type="bars" className="trigger custom-trigger"/>
          </Popover>)
          : (<Icon className="trigger custom-trigger" type={collapsed
              ? 'menu-unfold'
              : 'menu-fold'} onClick={() => this.toggleCollapsed()}/>)
      }<div className="right">
        <span className="action">
          <span className="name">{
              currentUser
                ? currentUser.full_name
                : ""
            }</span>
          <Dropdown overlay={menu}>
            <Button type="primary" ghost="ghost" shape="circle" icon="user"/>
          </Dropdown>
        </span>
      </div>
      <UserChangePasswordModalForm error={error} ref={this.saveFormRef} visible={visibleModal} onCancel={this.handleCancel} onSubmit={this.handleUpdatePassword}/>
    </Header>)
  }
}

export default HeaderNav;



// WEBPACK FOOTER //
// ./src/components/layouts/HeaderNav.js